import { hideDialogue } from "../../helpers";
import "../Styles/SubmitButton.css";
const SubmitButton = (props) => {
  const handleSubmit = () => {
    props.submitClicked();
    props.setVisibility(false);
    hideDialogue();
  };
  return (
    <>
      <button
       {...(props.disabled ? { disabled: props.disabled } : {})}
        type={props.isSubmitType ? `submit` : "button"}
        {...(!props.isSubmitType ? { onClick: handleSubmit } : {})}
        className="submit-button"
      >
        {props.text}
      </button>
    </>
  );
};

export default SubmitButton;
